<template src="./ExportBillComponent.html"></template>

<script>
export default {
  name: 'ExportBillComponent',
  props: {
    billData: {
      type: Object,
      required: true
    }
  },
  computed: {
    total() {
      return this.billData.items.reduce((sum, item) => sum + item.product_quantity * item.product_selling_price, 0);
    },
    totalFeeTaxIncluded() {
      return this.billData.items.reduce((sum, item) => {
        const price = item.product_selling_price;
        const qty = item.product_quantity;
        const taxRate = item.tax_rate || 0;

        const itemTotal = price * qty;
        const taxAmount = taxRate > 0 ? (itemTotal * taxRate) / 100 : 0;

        return sum + itemTotal + taxAmount;
      }, 0);
    }
  },
  mounted() {
    setTimeout(() => {
      const printWindow = window.open('', '', 'width=900,height=auto');

      // Lắng nghe sự kiện từ popup
      window.addEventListener('message', this.handlePrintResult);

      const style = `
      <style>
        .center { text-align: center; }
        .right { text-align: right; }
        .bold { font-weight: bold; }
        .line { border-top: 1px dashed #000; margin: 6px 6px; }
        .bill-line { white-space: pre; font-family: monospace; }
      </style>
    `;

      const content = this.$refs.billRef.innerHTML;

      const printHTML = `
      <html>
        <head>
          <title>INVOICEX</title>
          ${style}
        </head>
        <body>
          ${content}
          <script>
          window.opener && window.opener.postMessage({ type: 'ACTION_PRINT' }, '*');
            window.onload = function () {
              // Đợi một animation frame & timeout ngắn để đảm bảo nội dung đã render
              requestAnimationFrame(() => {
                setTimeout(() => {
                  const start = Date.now();
                  window.print();
                  window.onafterprint = function () {
                    const duration = Date.now() - start;
                    const canceled = duration < 1000;
                    window.opener && window.opener.postMessage({
                      type: canceled ? 'PRINT_CANCELED' : 'PRINT_DONE'
                    }, '*');
                    window.close();
                  };
                }, 200); // delay nhẹ để render
              });
            };
          <\/script>
        </body>
      </html>
    `;

      printWindow.document.write(printHTML);
      printWindow.document.close();
    }, 300);
  },
  methods: {
    format(n) {
      return (+n).toLocaleString('vi-VN');
    },
    formatDate(dateStr) {
      return new Date(dateStr).toLocaleString('vi-VN');
    },
    handlePrintResult(event) {
      const data = event?.data;
      if (!data || !['PRINT_DONE', 'PRINT_CANCELED', 'ACTION_PRINT'].includes(data.type)) {
        return;
      }

      window.removeEventListener('message', this.handlePrintResult);

      if (data.type === 'PRINT_DONE' || data.type === 'ACTION_PRINT') {
        this.$emit('printDone', this.billData);
      } else if (data.type === 'PRINT_CANCELED' || data.type === 'ACTION_PRINT') {
        this.$emit('cancel');
      }
    }
  }

}
</script>
